<template>
  <!--  战队列表-->
  <div class="Competition">
    <!--    <div class="team">-->
    <!--      <div class="sort">-->
    <!--        <div class="txt" @click="mySortClick">-->
    <!--          <div class="sortTxT">{{ sortTxT }}</div>-->
    <!--          <div :class="['arrow',{'active':isActive}]"></div>-->
    <!--        </div>-->
    <!--        <div :class="['sort_list',{'my_hidden':!isActive}]">-->
    <!--          <div v-for="(item,index) in sortList" :key="index" :class="['sort_list_item',{'select':selectNum===index}]"-->
    <!--               @click="mySortItemClick(index)">-->
    <!--            {{ item }}-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="team_list">-->
    <!--        <div v-for="(item,index) in competitionList" :key="index" class="team_item" @click="teamItemClick(item,index)">-->
    <!--          <div class="l">-->
    <!--            <img :src="item.url" alt>-->
    <!--          </div>-->
    <!--          <div class="r">-->
    <!--            <div class="tit">{{ item.tit }}</div>-->
    <!--            <div class="txt">{{ item.txt }}</div>-->
    <!--            <div class="sub_txt">{{ item.subTxT }}</div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div v-if="competitionList.length<=0" class="zwbs">
      <img alt src="@/assets/img_zwzd.png"/>
      <span>暂无合适战队...</span>
    </div>
  </div>

</template>

<script>
export default {
  name: 'competitionList',
  data() {
    return {
      competitionList: [
        // {
        //   url: require('@/assets/img_saishilogo.png'),
        //   tit: 'LEG是菜鸡战队',
        //   txt: '没啥说的.leg是菜鸡战队,干就完了!',
        //   subTxT: '#王者荣耀#'
        // },
        // {
        //   url: require('@/assets/img_saishilogo.png'),
        //   tit: '王之陨落无暇',
        //   txt: '王手无暇来会的,混子飞机票,1=全世界.',
        //   subTxT: '#Destiny2#'
        // },
        // {
        //   url: require('@/assets/img_saishilogo.png'),
        //   tit: '巅峰利维坦',
        //   txt: '巅峰利维坦速通,来猛男,也可以顺便全冰.',
        //   subTxT: '#Destiny2#'
        // }
      ], // 约赛战队数据list
      sortTxT: '时间排序', // 排序方式
      sortList: ['时间排序', '参赛排序', '约战次数'], // 排序方式list
      isActive: false, // 排序方式list是显示还是隐藏
      selectNum: 0, // 第几个被选中
    }
  },
  mounted() {
    this.resetHeight()
  },
  methods: {
    resetHeight(newValue) {
      var h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      let my_tab = document.querySelector('.my_tab_3')
      my_tab.style.height = h - 44 + 'px'
    },
    teamItemClick(item, index) {
      this.$router.push('/teamInfo')
    },
    mySortClick() {
      this.isActive = !this.isActive
    },
    mySortItemClick(index) {
      this.sortTxT = this.sortList[index]
      this.selectNum = index
      this.isActive = false
    }
  }
};
</script>

<style lang="scss">
.Competition {
  height: 100%;
  //padding: 16px 16px 0;
  //box-sizing: border-box;

  .team {
    height: 100%;

    .sort {
      text-align: left;
      position: relative;

      .txt {
        width: 94px;
        font-size: 15px;
        display: flex;
        align-items: center;

        .sortTxT {
          padding-right: 16px;
        }

        .arrow {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          border: 1px solid #333333;
          border-left: none;
          border-bottom: none;
          transform: rotate(45deg);
          transition: all 0.3s ease;
        }

        .arrow.active {
          transform: rotate(135deg);
        }
      }

      .sort_list {
        transition: all 0.6s ease;
        width: 100px;
        line-height: 26px;
        border: 0.5px solid #999;
        text-indent: 4px;
        left: -6px;
        top: 24px;
        position: absolute;
        z-index: 9;
        background: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

        .sort_list_item {
          font-size: 14px;
          color: #666;
        }

        .sort_list_item.select {
          background: #4a7dfe;
          color: #fff;
        }
      }

      .my_hidden {
        display: none;
      }
    }

    .team_list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 16px;

      .team_item {
        width: 100%;
        min-width: 343px;
        height: 87px;
        border-radius: 8px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .l {
          margin-left: 16px;

          img {
            width: 55px;
            height: 55px;
          }
        }

        .r {
          flex: 1;
          padding-left: 16px;
          text-align: left;
          font-size: 12px;
          line-height: 22px;

          .tit {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
          }

          .txt {
            color: #999999;
          }

          .sub_txt {
            color: #4A7DFE;
          }
        }
      }

      .team_item:last-child {
        margin-bottom: 0;
      }
    }
  }

  .zwbs {
    //height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% - 44px));

    span {
      font-size: 12px;
      color: #333333;
      margin-top: 24px;
    }
  }
}

</style>
